// import _ from 'lodash'
import request from '@/utils/request'

const prefix = '/django_rest/alumni'

export default {
  uploadAlumniFile (file) {
    const fileData = new FormData()
    fileData.append('file', file)
    return request.post(`${prefix}/` + 'alumni-upload/', fileData)
  },
  getAlumniList () {
    return request.get(`${prefix}/`)
  },
  getAlumni (alumniId) {
    return request.get(`${prefix}/${alumniId}/`)
  },
  createAlumni (alumniData) {
    return request.post(`${prefix}/`, alumniData)
  },
  updateAlumni (alumniData) {
    return request.put(`${prefix}/${alumniData.id}/`, alumniData)
  }
}
